export default function getActivityEventsReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_ACTIVITY_EVENT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_ACTIVITY_EVENT_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_ACTIVITY_EVENT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}